// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/Tabs/RefreshButton/query_tx_cards.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_Tabs_RefreshButton($patient_id: uuid!) {
  vaxiom_tx_cards(
    where: { patient: { _id: { _eq: $patient_id } }, deleted: { _eq: false } }
  ) {
    id
    _id
    name
    tx_category {
      id
      name
    }
    txs(where: { deleted: { _eq: false } }) {
      id
      _id
      has_unrealized_invoices
      name
      status
      start_date
      estimated_start_date
      end_date
      estimated_end_date
      colors
      notes
      organization {
        id
        _id
      }
    }
  }
}

`